import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Plan } from '../../models/plan';
import { ProviderService } from 'src/app/services/provider.service';
import { map } from 'highcharts';
import { take } from 'rxjs';

@Component({
  selector: 'app-packages',
  templateUrl: './packages.component.html',
  styleUrls: ['./packages.component.css'],
})
export class PackagesComponent implements OnInit {
  plans: Plan[] = [];
  @Input() merchant: string = '';
  @Input() operator: string = '';
  @Input() clear: boolean = false;
  @Output() onSelectPlan : EventEmitter<Plan[]> = new EventEmitter<Plan[]>();

  selectedValue : string[] | null= null;
  subscription: any;
  merchantSubscription: any;

  constructor(private providerService: ProviderService) {}
  checked = true;
  isLoading = false;
  isCheckedAllPlans = false;
  isDisabledButton = false;

  ngOnInit() {

    this.subscription = this.providerService.onChangeOperator$.subscribe(res => {
 
      this.selectedValue = null;
      this.operator = res.id;
      // this.loadPlans(true);
    });

   this.merchantSubscription = this.providerService.onFirstMerchant$.subscribe(res => {
  
      this.merchant = res.merchant.id;
      this.operator = res.operator.id;

     this.loadPlans(true);
    });
  }

  ngOnChanges(changes: SimpleChanges): void { 
    if ((changes['clear'] && !changes['clear'].isFirstChange())) {   
      this.plans = [];
    }
  }

  loadPlans(isAllPlanSelecte : boolean){
 
    if (!this.merchant || !this.operator) {
      this.plans = [];
      return;
    }

    this.isLoading = true;

    this.providerService
    .loadPackages(this.merchant, this.operator)
    .subscribe({
      next : (plans) => {
       
        this.plans = plans; 
        this.isLoading = false;
        
        if (isAllPlanSelecte) {
          this.selectedValue  = this.plans.map(p => p.planId);
          this.onPlanChange(this.selectedValue);       
        }
  
       
      },
      error : (error) => { this.isLoading = false}
    });
  } 

  onChecked(){

    //if unchecked the checkbox then clear plans.
    if (!this.isCheckedAllPlans) {
      this.plans = [];

      this.selectedValue  = this.plans.map(p => p.planId);
      this.onPlanChange(this.selectedValue);    
    }

    this.loadPlans(this.isCheckedAllPlans);
  }
 
  onPlanChange(plans : string[] ){

   
    this.plans.forEach(plan => {
      plan.isChecked = plans.includes(plan.planId);
  });
    const checkedPlans = this.plans.filter(p => p.isChecked);

     this.onSelectPlan.emit(checkedPlans);
  }
  
  ngOnDestroy(): void {
    if(this.subscription)
    this.subscription.unsubscribe();

    if (this.merchantSubscription) {
      this.merchantSubscription.unsubscribe();
    }
  }
}
